import { render, staticRenderFns } from "./CompetencyDomain.vue?vue&type=template&id=440cff59&scoped=true"
import script from "./CompetencyDomain.vue?vue&type=script&lang=js"
export * from "./CompetencyDomain.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDomain.vue?vue&type=style&index=0&id=440cff59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440cff59",
  null
  
)

export default component.exports